import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { AutomationsSharedModule } from '../automations-shared.module'
import { ReviewAutomationsOverlayComponent } from './automations-overlay/review-automations-overlay.component'
import { ReviewAutomationsComponent } from './review-automations.component'
import { ReviewAutomationOverlayComponent } from './automation-overlay/review-automation-overlay.component'
import { ChannelsLibraryModule } from '@tokeet-frontend/channels'

const components = [
  //
  ReviewAutomationsComponent,
  ReviewAutomationsOverlayComponent,
  ReviewAutomationOverlayComponent,
]

@NgModule({
  imports: [CommonModule, AutomationsSharedModule, ChannelsLibraryModule],
  declarations: [...components],
  providers: [],
  exports: [AutomationsSharedModule, ...components],
})
export class ReviewAutomationsModule {}
